<template>
  <div>
    <div class="filtro-personalizacao">

      <div class="filtro-content">
        <Loader v-if="loading" style="margin: 0 auto" />
        <div v-if="!loading">
          <template v-for="(sub, index) in this.filtro.items">

            <template v-if="((sub.Tipo != 'I' || sub.Valores.length > 0))">

              <div class="col-lg-4">
                <div class="form-group">
                  <label>{{ sub.Descricao }}</label> <span v-if="sub.obrigatorio" class="text-alert">*</span>

                  <template v-if="sub.Descricao == 'ESTRUTURA'">
                    <select class="form-control" id="estrutura">
                      <option value=""></option>
                      <option class="option-filter" v-for="atrib in sub.Valores" :key="atrib.Id" :value="atrib.Id">{{
                        atrib.Descricao }}
                      </option>
                    </select>
                  </template>

                  <template v-if="sub.Descricao == 'INVERSOR SOLAR'">
                    <select class="form-control" id="marca-inversor">
                      <option value="">TODOS</option>
                      <option class="option-filter" v-for="atrib in sub.Valores" :key="atrib.Id" :value="atrib.Id">{{
                        atrib.Descricao }}
                      </option>
                    </select>
                  </template>

                  <template v-if="sub.Descricao == 'TENSÃO SAIDA DO INVERSOR'">
                    <select class="form-control" id="tensao-inversor">
                      <option value="">TODOS</option>
                      <option class="option-filter" v-for="atrib in sub.Valores" :key="atrib.Id" :value="atrib.Id">
                        {{ atrib.Descricao }}
                      </option>
                    </select>
                  </template>

                  <template v-if="sub.Descricao == 'PAINEL SOLAR'">
                    <select class="form-control" id="marca-painel">
                      <option value="">TODOS</option>
                      <option class="option-filter" v-for="atrib in sub.Valores" :key="atrib.Id" :value="atrib.Id">
                        {{ atrib.Descricao }}
                      </option>
                    </select>
                  </template>

                  <template v-if="sub.Descricao == 'POTÊNCIA DO GERADOR (KWP)'">
                    <div style="display: flex; gap: 15px">
                      <input class="form-control text-right" id="potencia" />
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </template>

          <div class="col-lg-4">
            <div class="form-group">
              <label>TIPO DE GERADOR</label>

              <select class="form-control" id="tipo-sistema">
                <option class="option-filter" value="on-grid">ON GRID </option>
                <option v-show="podePersonalizarHibrido" class="option-filter" value="hibrido">HIBRIDO </option>
              </select>
            </div>
          </div>
        </div>
        <button v-if="!loading" class="btn btn-primary" type="button" @click="buscarProdutos"><i class="fa fa-filter"></i>
          Buscar</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.filtro-personalizacao {
  padding: 20px 15px 10px;
  background: #d8f1fe;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  border-radius: 4px;
}

.filtro-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.filtro-content button {
  width: 120px;
}

button .fa {
  margin-right: 4px;
}

.btn {
  border-radius: 8px;
}

@media (max-width: 700px) {
  .filtro-content {
    flex-direction: column;
  }
}
</style>
<script>

import { v4 as uuidv4 } from 'uuid'

export default {
  name: "ProductCustomizationFilters",
  props: ["category", "brands", "name", "shouldRefresh"],
  components: {

  },
  mounted() {
    const url = new URL(location.href)
    const codProduto = url.searchParams.get('prod')

    if(!codProduto) {
      this.getFilters(false);
    }
    const session = JSON.parse(localStorage.getItem('usuarioLogado'))

    this.podePersonalizarHibrido = session && session.DadosCliente.TipoUsuario === 2

    this.getPercentualPotencia();
  },
  watch: {
    shouldRefresh(newValue) {
      if (newValue) {
        this.getFilters(false);
      }
    }
  },
  data() {
    return {
      loading: true,
      filtrosHabiitados: [
        { descricao: 'ESTRUTURA', obrigatorio: true },
        { descricao: 'POTÊNCIA DO GERADOR (KWP)', obrigatorio: true },
        { descricao: 'INVERSOR SOLAR', obrigatorio: false },
        { descricao: 'PAINEL SOLAR', obrigatorio: false },
        { descricao: 'TENSÃO SAIDA DO INVERSOR', obrigatorio: false },
      ],
      filtro: {
        filtroMontado: false,
        items: [],
        query: "",
        tipoSistema: "",
      },
      percentualPotencia: 10,
      podePersonalizarHibrido: false,
    };
  },
  methods: {

    async getPercentualPotencia() {
      const xhr = new XMLHttpRequest();

      xhr.onload = () => {
        if (xhr.status == 200) {
          this.percentualPotencia = parseInt(xhr.responseText)
        }
      };
      xhr.open("GET", this.$apiUrl + "Produto.svc/GetPercentualPotencia");
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.withCredentials = true;
      xhr.send()
    },

    getFilters(loadProdutos) {
      if (this.filtro.query) {
        window.history.pushState("", "", `?filtro=${this.filtro.query}`);
      }

      this.$emit('setLoading', { loading: true, clearProducts: loadProdutos });

      const xhr = new XMLHttpRequest();

      xhr.onload = () => {
        if (xhr.status == 200) {
          const json = JSON.parse(xhr.responseText);

           this.filtro.items = json.Filtros.Dados;

          this.filtro.items = this.filtro.items
            .filter(x => this.filtrosHabiitados.map(y => y.descricao).includes(x.Descricao))
            .map(x => ({
              obrigatorio: this.filtrosHabiitados.filter(y => y.descricao == x.Descricao)[0].obrigatorio,
              ...x
            }));

          this.filtro.items = this.filtro.items.sort((a, b) => b.obrigatorio - a.obrigatorio);

          this.filtroMontado = true;
        }

        this.$emit('setLoading', { loading: false, clearProducts: false });

        this.loading = false;
      };
      xhr.open("POST", this.$apiUrl + "Produto.svc/getfiltroeprodutosporsegmento");
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.withCredentials = true;

      if (!this.filtroMontado) {
        xhr.send(JSON.stringify({
          slug: `energia-solar/gerador-de-energia-solar-fotovoltaico${this.tipoSistema ? `/${this.tipoSistema}` : ""}`,
          origem: 'categoria',
          filtroAtributos: '',
          idAcionado: null,
          offset: 0,
          orderby: 1
        }));
      }

      if (loadProdutos) this.$emit("updateFilterId", { tipoSistema: this.tipoSistema, id: uuidv4() });
    },

    buscarProdutos() {

      if (!this.validarFiltros()) return;

      this.filtro.query = "";

      let queryIds = [];

      $("#estrutura .option-filter:selected").each((a, b) => {
        const val = $(b).val();
        queryIds.push(val)
      });

      $("#marca-inversor .option-filter:selected").each((a, b) => {
        const val = $(b).val();
        queryIds.push(val)
      });

      $("#marca-painel .option-filter:selected").each((a, b) => {
        const val = $(b).val();
        queryIds.push(val)
      });

      $("#tensao-inversor .option-filter:selected").each((a, b) => {
        const val = $(b).val();
        queryIds.push(val)
      });

      this.tipoSistema = $("#tipo-sistema .option-filter:selected").val();

      const potencia = parseFloat($("#potencia").val().replace(',', '.'))
      const percentual = this.percentualPotencia

      let queryPotencia = `3:${potencia * (100 - percentual) / 100}~${potencia * (100 + percentual) / 100}`;
      this.filtro.query = `${queryIds.join(';')};${queryPotencia}`;

      this.getFilters(true);
    },

    validarFiltros() {
      let error = 0;

      $("#potencia").removeClass("is-invalid")
      $("#estrutura").removeClass("is-invalid")

      if (!$("#potencia").val()) {
        $("#potencia").addClass("is-invalid")
        error = 1;
      }

      if ($("#estrutura .option-filter:selected").length == 0) {
        $("#estrutura").addClass("is-invalid")
        error = 1;
      }

      return error == 0;
    }
  }
};

</script>
